import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const PlaygroundV2Page = withCompass(
  () => import("../../workspace/mj/playground-v2")
);

export function MichalJezRoutes() {
  return (
    <Switch>
      <Route path="/mj/playground-v2" component={PlaygroundV2Page} />
    </Switch>
  );
}

export const slug = "mj";
